import type { TLayout } from '../models/playlist'
import type { TRssLayoutId } from '../models/rssDirectoryRef'
import { SINGLE_SECTION_HORIZONTAL_LAYOUT } from '../data/singleSectionLayouts'

export const RSS_STORY_FULL_LAYOUT: TLayout = {
  ...SINGLE_SECTION_HORIZONTAL_LAYOUT,
  id: 'rss-story-full',
  name: 'RSS G1 story'
}

/** @deprecated Use RSS_STORY_FULL_LAYOUT */
export const RSS_HEADLINE_STRIP_LAYOUT = RSS_STORY_FULL_LAYOUT

/** @deprecated Use RSS_STORY_FULL_LAYOUT */
export const RSS_TICKER_FOOTER_LAYOUT = RSS_STORY_FULL_LAYOUT

export function resolveRssLayoutForTemplate(_layoutId?: TRssLayoutId): TLayout {
  return RSS_STORY_FULL_LAYOUT
}
